// app/javascript/landing/hooks/useScrollHeader.ts
import { useEffect, useState } from "react";

/**
 * Solo indica si estamos cerca de la parte superior.
 * No oculta nunca el header.
 */
export function useScrollHeader(threshold = 10) {
  const [atTop, setAtTop] = useState(true);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || 0;
      setAtTop(y < threshold);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return { atTop };
}
